import React from 'react';
import {
  Autocomplete,
  Box,
  TextField,
  Typography,
  createFilterOptions,
} from '@mui/material';

const filterVariedades = createFilterOptions({
  stringify: (option) => `${option.nombre} ${option.codigo}`,
});

export const VariedadNavAutocomplete = ({
  label = 'Variedad',
  loading = false,
  onChange,
  options = [],
  placeholder = 'Seleccione variedad',
  required = false,
  size = 'medium',
  sx,
  value = '',
}) => (
  <Autocomplete
    fullWidth
    size={size}
    sx={sx}
    options={options}
    value={options.find((option) => String(option.id) === String(value)) || null}
    onChange={(_, option) => onChange?.(option?.id || '')}
    getOptionLabel={(option) => option.nombre}
    isOptionEqualToValue={(option, selectedOption) => option.id === selectedOption.id}
    filterOptions={filterVariedades}
    loading={loading}
    loadingText="Cargando variedades..."
    noOptionsText="No se han encontrado variedades"
    renderOption={(props, option) => {
      const { key, ...optionProps } = props;

      return (
        <Box component="li" key={key} {...optionProps}>
          <Typography sx={{ fontSize: 14, fontWeight: 500, color: 'text.primary' }}>
            {option.nombre}
          </Typography>
        </Box>
      );
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        required={required}
        label={label || undefined}
        placeholder={placeholder}
      />
    )}
  />
);
